<app-sidebar [(isOpen)]="resultTableService.isSidebarOpen">
  <div class="md:mb-16">
    <app-filters-sidebar-header></app-filters-sidebar-header>

    <app-filters-sidebar-size-filter key="size" label="Size"/>
    <app-filters-sidebar-filter-checkboxes key="delivery" label="Availability"/>
    <app-filters-sidebar-filter-checkboxes key="specials" label="Specials"/>
    <app-filters-sidebar-filter-checkboxes key="brand" label="Brand"/>
    <app-filters-sidebar-filter-checkboxes key="features.seasonal_designation" label="Seasonal Designation"/>
    <app-filters-sidebar-filter-checkboxes key="features.inventory_type" label="Type"/>
    <app-filters-sidebar-filter-checkboxes key="features.speed_rating" label="Speed Rating"/>
    <app-filters-sidebar-filter-checkboxes key="features.load_index" label="Load Index"/>
    <app-filters-sidebar-warranty-filter key="features.mileage_warranty" label="Warranty"/>
    <app-filters-sidebar-filter-checkboxes key="features.sidewall" label="Sidewall"/>
    <app-filters-sidebar-filter-checkboxes key="features.load_range" label="Load Range"/>
    <app-filters-sidebar-filter-checkboxes key="features.run_flat" label="Run Flat"/>
  </div>
</app-sidebar>
